<div
	[class.bb-button]="type !== 'round-icon-button'"
	class="{{ type }} {{ theme }}-theme {{ backgroundColor }}-bg {{ size }}-size {{ join }}-join"
	[class.bb-active]="active"
	[class.bb-disabled]="disabled || loading"
	[class.naked]="naked"
	[class.round]="round"
	[style.--size]="pxSize + 'px'"
	[style.padding]="pxSize ? '0' : ''"
>
	<i *ngIf="icon && !loading" class="fa {{ iconSize ? 'fa-' + iconSize : '' }}" [ngClass]="'fa-' + icon"></i>
	<i *ngIf="loading" class="fa fa-circle-o-notch fa-spin"></i>
	<ng-content></ng-content>
</div>
